import type { IxcPaymentsV1AccountNumberKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const PAYMENTS_ACCOUNT_NUMBER_BASE_PATH = getResolvedPath('/clearing/finance/payment/account-number');

export const getPaymentsAccountNumberPath: EntityPathBuilder<IxcPaymentsV1AccountNumberKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return PAYMENTS_ACCOUNT_NUMBER_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.accountNumberId) {
        return undefined;
      }

      return getResolvedPath(`${PAYMENTS_ACCOUNT_NUMBER_BASE_PATH}/$accountNumberId`, context.keys);
    }
  }
};

export function getPaymentsAccountNumberDetailPath(accountNumberId: string | undefined) {
  if (!accountNumberId) {
    return undefined;
  }

  return getPaymentsAccountNumberPath({ kind: 'detail', keys: { accountNumberId } });
}
